const defaultMenuHeading = 'Menu';
let $body;
let $menu;
let $menuOverlay;
let $menuTriggerBtns;
let $initFocus;
let menuOpen = false;

function cacheDOM() {
  $body = document.querySelector('body');
  $menu = document.querySelector('.js-menu');
  if ($menu) {
    $initFocus = $menu.querySelector('.js-menu__init-focus');
  }
  $menuOverlay = document.querySelector('.js-menu-overlay');
  $menuTriggerBtns = [...document.querySelectorAll('.js-menu-trigger')];
}

function createSubnav() {
  const $subNavs = [...$menu.querySelectorAll('.js-menu__subnav')];
  const $subNavTriggers = [...$menu.querySelectorAll('.js-menu__subnav-trigger')];
  const $subNavCloseBtns = [...$menu.querySelectorAll('.js-menu__subnav-close-btn')];
  const $menuHeading = $menu.querySelector('.js-menu__heading');

  function updateMenuHeading(heading = false) {
    const newHeading = heading || defaultMenuHeading;
    if ($menuHeading) {
      $menuHeading.innerText = newHeading;
    }
  }

  function toggleSubnav(targetIndex = false, menuText = false) {
    $subNavs.forEach(($subnav, currentIndex) => {
      if (targetIndex === currentIndex) {
        $subnav.classList.add('menu-site__subnav--is-primed');
        setTimeout(() => {
          $subnav.classList.add('menu-site__subnav--is-active');
        }, 10);
        $subnav.setAttribute('aria-hidden', false);
        $subnav.focus();
      } else {
        $subnav.classList.remove('menu-site__subnav--is-active');
        setTimeout(() => {
          $subnav.classList.remove('menu-site__subnav--is-primed');
        }, 350);
        $subnav.setAttribute('aria-hidden', true);
      }
      updateMenuHeading(menuText);
    });
  }

  $subNavTriggers.forEach(($trigger, subnavIndex) => {
    $trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const menuTitle = $trigger?.dataset?.menuTitle;
      toggleSubnav(subnavIndex, menuTitle);
    });
  });

  $subNavCloseBtns.forEach(($btn) => {
    $btn.addEventListener('click', () => toggleSubnav(false));
  });
}

function toggleMenu() {
  function hide() {
    // Add aria state
    $menu.setAttribute('aria-hidden', true);
    // Hide nav and overlay
    $menuOverlay.classList.remove('menu-site-overlay--is-active');
    $menu.classList.remove('menu-site--is-active');
    setTimeout(() => {
      $menuOverlay.classList.remove('menu-site-overlay--is-primed');
      $menu.classList.remove('menu-site--is-primed');
    }, 350);
    menuOpen = false;
    // Enable scroll on body
    setTimeout(() => {
      $body.classList.remove('disable-scroll');
      $menu.classList.remove('menu-site--force-scroll');
    }, 100);
  }

  function show() {
    // Add aria state
    $menu.setAttribute('aria-hidden', false);
    // Show nav and overlay
    $menuOverlay.classList.add('menu-site-overlay--is-primed');
    $menu.classList.add('menu-site--is-primed');
    setTimeout(() => {
      $menuOverlay.classList.add('menu-site-overlay--is-active');
      $menu.classList.add('menu-site--is-active');
    }, 10);
    menuOpen = true;

    // Focus inital item if set
    if ($initFocus) $initFocus.focus();

    // Disable scroll on body
    setTimeout(() => {
      $body.classList.add('disable-scroll');
      $menu.classList.add('menu-site--force-scroll');
    }, 100);

    function handleEscKeyNav(e) {
      if (e.defaultPrevented) {
        return;
      }

      const key = e.key || e.keyCode;
      if (key === 'Escape' || key === 'Esc' || key === 27) {
        // Hide nav
        hide();
        // Remove listener for escape key
        document.removeEventListener('keyup', handleEscKeyNav);
      }
    }

    // Listen for escape key
    document.addEventListener('keyup', handleEscKeyNav);
  }

  if (menuOpen) {
    hide();
  } else {
    show();
  }
}

function menuTriggers() {
  $menuTriggerBtns.forEach(($trigger) => {
    // Bind click event to all buttons
    $trigger.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMenu();
    });
  });
}

export default function init() {
  cacheDOM();
  if ($menu && $menuOverlay) createSubnav();
  if ($menuTriggerBtns && $menuTriggerBtns.length) menuTriggers();
}
